import { render, staticRenderFns } from "./PaymentBraintree.vue?vue&type=template&id=b93c5606&"
import script from "./PaymentBraintree.vue?vue&type=script&lang=js&"
export * from "./PaymentBraintree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports